"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _hooks = require("@alycecom/hooks");

var styles = {
  tabs: {
    maxWidth: 210,
    '& .MuiTabs-indicator': {
      width: '100%',
      backgroundColor: function backgroundColor(_ref) {
        var palette = _ref.palette;
        return palette.primary.superLight;
      }
    },
    '& .MuiTab-root': {
      width: '100%',
      height: 42,
      justifyContent: 'flex-start',
      padding: function padding(_ref2) {
        var spacing = _ref2.spacing;
        return spacing(1, 0, 1, 7);
      },
      margin: function margin(_ref3) {
        var spacing = _ref3.spacing;
        return spacing(1, 0);
      },
      color: function color(_ref4) {
        var palette = _ref4.palette;
        return palette.grey.main;
      },
      zIndex: 1
    },
    '& .MuiTab-root:first-of-type': {
      marginTop: 0
    },
    '& .MuiTab-root:last-of-type': {
      marginBottom: 0
    },
    '& .MuiTab-root.Mui-selected': {
      color: function color(_ref5) {
        var palette = _ref5.palette;
        return palette.primary.main;
      }
    }
  }
};

var LeftSectionNav = function LeftSectionNav(_ref6) {
  var tabs = _ref6.tabs,
      tabsProps = _ref6.TabsProps;

  var _ref7 = tabsProps || {},
      _ref7$sx = _ref7.sx,
      sx = _ref7$sx === void 0 ? [] : _ref7$sx,
      value = _ref7.value,
      onChange = _ref7.onChange,
      restTabsProps = (0, _objectWithoutProperties2.default)(_ref7, ["sx", "value", "onChange"]);

  (0, _hooks.useWindowScrollToEffect)('top', [value]);
  return /*#__PURE__*/_react.default.createElement(_material.Tabs, (0, _extends2.default)({
    value: value,
    onChange: onChange,
    orientation: "vertical",
    sx: [styles.tabs].concat((0, _toConsumableArray2.default)(Array.isArray(sx) ? sx : [sx]))
  }, restTabsProps), tabs);
};

var _default = LeftSectionNav;
exports.default = _default;